import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, Home } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const proposalId = searchParams.get('proposalId');

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }} data-testid="payment-cancel-page">
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '48px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: '#fef2f2',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <XCircle size={48} style={{ color: '#dc2626' }} />
        </div>
        
        <h1 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '12px' }}>
          Payment Cancelled
        </h1>
        
        <p style={{ color: '#6b7280', marginBottom: '32px' }}>
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Button variant="outline" onClick={() => navigate('/')} data-testid="go-home-button">
            <Home size={18} /> Dashboard
          </Button>
          {proposalId && (
            <Button 
              onClick={() => navigate(`/proposal/${proposalId}`)}
              style={{ background: '#e74c3c' }}
              data-testid="back-to-proposal-button"
            >
              <ArrowLeft size={18} /> Back to Proposal
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
